import { CommonValidationMethods } from './common_validation_methods';
import { IValidationError } from './validations';
import { ValidationTypeArgs, CommonTypeBasedArgs } from './validation_types';

export interface NoDuplicatesTypeArgs extends CommonTypeBasedArgs {
  type: 'NO_DUPLICATES';
  whiteListValueSet?: Set<any>;
}

export class NoDuplicationValidation extends CommonValidationMethods {
  static type = 'NO_DUPLICATES';

  static isNoDuplication(
    validationTargetDataArgs: ValidationTypeArgs
  ): validationTargetDataArgs is NoDuplicatesTypeArgs {
    return validationTargetDataArgs.type === NoDuplicationValidation.type;
  }

  static validate(sourceData: any, sourceKey: string, targetDataConfig: NoDuplicatesTypeArgs) {
    if (NoDuplicationValidation.isWhiteListedValue(sourceData, sourceKey, targetDataConfig)) {
      return true;
    }
    return CommonValidationMethods.getFilteredData(sourceData, sourceKey, targetDataConfig).length === 1;
  }

  static getErrorDetail(sourceData: any, sourceKey: string, targetDataConfig: NoDuplicatesTypeArgs): IValidationError {
    const conditionChecked = NoDuplicationValidation.getConditionChecked(sourceData, sourceKey, targetDataConfig);
    const conditionCheckedMessage = `Condition checked was ${JSON.stringify(conditionChecked)}.`;

    const totalDuplicates = CommonValidationMethods.getFilteredData(sourceData, sourceKey, targetDataConfig);
    const totalDuplicatesMessage = `Duplicate entries: ${JSON.stringify(totalDuplicates.slice(1))}`; //Except the first entry, which is valid

    const totalDuplicatesFound = totalDuplicates.length - 1; //One entry is the valid one, so that count minus total
    const totalDuplicatesFoundMessage = `Total duplicates found: ${totalDuplicatesFound}.`;

    const NoDuplicatesFailedMessage = `No duplicates check failed for ${JSON.stringify(sourceData)} in ${JSON.stringify(
      targetDataConfig['data']
    )}.`;

    const errorMessage = `${NoDuplicatesFailedMessage} ${conditionCheckedMessage} ${totalDuplicatesFoundMessage} ${totalDuplicatesMessage}`;

    return {
      errorMessage,
      type: NoDuplicationValidation.type,
      ...super.getErrorDetail(sourceData, sourceKey, targetDataConfig)
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/pi-validation/src/validation/duplicate_validation.ts